import axios from 'axios';
import { EntityDecisionsParams } from '../entity.types';

export function fetchDecisionByEntities(params: EntityDecisionsParams) {
  return axios.get('/getDecisionByEntities', {
    params,
  });
}
